import React from "react";
import { faBriefcase } from "@fortawesome/free-solid-svg-icons";

import Card from "../common/card";

import "./styles/works.css";

const Works = () => {
	return (
		<div className="works">
			<Card
				icon={faBriefcase}
				title="Work"
				body={
					<div className="works-body">
						<div className="work">
							<img
								src="./ge.png"
								alt="ge"
								className="work-image"
							/>
							<div className="work-title">General Electric Healthcare</div>
							<div className="work-subtitle">
								AI Engineer - Intern
							</div>
							<div className="work-duration">Jan 2024 - July 2024</div>
						</div>

						<div className="work">
							<img
								src="./minerva.png"
								alt="minerva"
								className="work-image"
							/>
							<div className="work-title">Minerva Rockets</div>
							<div className="work-subtitle">
								Avionics Engineer
							</div>
							<div className="work-duration">July 2021 - Aug 2022</div>
						</div>
					</div>
				}
			/>
		</div>
	);
};

export default Works;
